import api from './client.js'

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout'),
  register: (userData) => api.post('/auth/register', userData),
  getCurrentUser: () => api.get('/auth/profile'),
  updateProfile: (profileData) => api.put('/auth/profile', profileData),
  searchUsers: (query) => api.get('/auth/users/search', { params: { query } }),
}

export const userAPI = {
  uploadAvatar: (formData) => api.post('/users/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteAvatar: () => api.delete('/users/avatar'),
  uploadBanner: (formData) => api.post('/users/banner', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  deleteBanner: () => api.delete('/users/banner'),
  setBannerSource: (source) => api.put('/users/banner/source', { source }),
  getUserProfile: (userId) => api.get(`/users/profile/${userId || ''}`),
  updateProfile: (data) => api.put('/users/profile', data),
  adminRemoveAvatar: (userId) => api.delete(`/users/avatar/${userId}`),
}
